import { Button, Card, Divider, List, Tag, Typography, Modal, Select } from "antd"
import { useEffect, useState } from "react";
import { Empty } from 'antd';
import bin_img from '../../../assets/dashboard/bin_img.png';
import ManageBinService from "../../../services/ManageBinService";
import { useNavigate } from "react-router";

const GSMDashboard = ({ userData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [displayBin, setDisplayBin] = useState([]);
  const [displayBinData, setDisplayBinData] = useState(false);
  const [binId, setBinId] = useState();
  const [filteredBins, setFilteredBins] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ManageBinService.getBinData();

        const washingBins = response.data;
        const filteredBins = washingBins.filter(bin => bin.bin_location === "garment_super_market");

        console.log("Washing bins:", washingBins);
        console.log("filteredBins location GSM:", filteredBins);
        setDisplayBin(filteredBins);

      } catch (error) {
        console.error("Error fetching bin data:", error);
      }
    };

    fetchData();
  }, []);

  const uniqueLocations = [
    ...new Set(displayBin.map((bin) => bin.bin_location))
  ];

  const options = uniqueLocations.map((location) => ({
    label: location,
    value: location
  }));

  const handleChange = (value) => {
    if (value.length === 0) {
      setFilteredBins(null);
      return;
    }

    const newFilteredBinData = displayBin.filter(bin =>
      value.includes(bin.bin_location)
    );
    setFilteredBins(newFilteredBinData);
  };

  const handleCardClick = async (bin) => {
    setBinId(bin.bin_id);
    console.log(bin.bin_id);

    navigate(`/gsm/bin/View?binId=${encodeURIComponent(bin.bin_id)}`);
  };

  // Determine which data to display
  const binsToDisplay = filteredBins || displayBin;

  return (
    <>
      <div style={{ textAlign: 'right', paddingBottom: '10px' }}>

      </div>
      <div style={{ marginTop: 16 }}>
        {binsToDisplay.length > 0 ? (
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 3,
              lg: 4,
              xl: 5,
            }}
            dataSource={binsToDisplay}
            renderItem={(bin) => (
              <>
                <List.Item >
                  <>
                    {bin.bin_location && (
                      <Tag
                        color={bin.bin_location === "garment_super_market"
                          ? "#FFC0CB"
                          : "#000000" // Default color if no match
                        }
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          whiteSpace: 'nowrap',
                          color:
                            bin.bin_location === "garment_super_market"
                              ? "#000000" // Black text for Yellow
                              : "#FFFFFF", // Default text color for Black
                          width: '50%',
                          height: '100%',
                          textAlign: 'center',
                          fontWeight: 'bold',
                        }}
                      >
                        {bin.bin_location === "garment_super_market"
                          ? "In GSM"
                          : "Not Found"}
                      </Tag>
                    )}
                    <Card
                      bordered={false}
                      size="small"
                      style={{
                        textAlign: "center",
                        borderRadius: 8,
                        width: '50%',
                        height: '50%',
                        boxShadow: 'none',
                        cursor: 'pointer', // Added to show it's clickable
                      }}
                      onClick={() => handleCardClick(bin)}
                      cover={<img src={bin_img}
                        style={{ marginBottom: '-20px' }} />
                      }
                    >
                      <div style={{
                        position: 'absolute',
                        top: '53%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        whiteSpace: 'nowrap'
                      }}>
                        <p style={{
                          height: 24,
                          color: 'black',
                        }} size='small'><strong>{bin.bin_name}</strong></p>
                      </div>
                    </Card>
                    <Tag
                      color={bin.bin_full === "yes" ? "#87d068" : "transparent"}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        whiteSpace: "nowrap",
                        marginBottom: "-10px",
                        color: bin.bin_full === "yes" ? "white" : "black",
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                        fontWeight: "bold",
                        border: bin.bin_full === "yes" ? "none" : "1px solid black",
                      }}
                    >
                      {bin.total_quantity || 0} Pcs
                    </Tag>
                  </>
                </List.Item>
                <Divider />
              </>
            )}
          />
        ) : (
          <Empty description="No bins found for the GSM location(s)" />
        )}
      </div>

    </>
  );
};

export default GSMDashboard;